import {addGlobals} from '../modules/addGlobals';
import {uPopupFunc} from '../modules/uPopup';
import ready from '../modules/ready';
import svg from '../modules/svg'; /* svg4everybody for ie */
import {mm} from '../modules/mm';
import {mainLogo} from  '../modules/mainLogo';
import {myMap} from  '../modules/myMap';
import {Gallery} from  '../modules/Gallery';
import {CombinedPlayer} from  '../modules/CombinedPlayer';
import fullscreenGallery from  '../modules/fullscreenGallery';
import {YaShare2} from  '../modules/YaShare2';
import {Winners} from  '../modules/Winners';
import {Help} from  '../modules/Help';


uPopupFunc(window, document);

APP.modules = {
    actions: {
        mm: function(el){mm(el)},
        mainLogo: function(el){mainLogo(el)},
        myMap: function(el){myMap(el)},
        Gallery: function(el){new Gallery(el)},
        CombinedPlayer: function(el){new CombinedPlayer(el)},
        fullscreenGallery: function(el){fullscreenGallery(el)},
        YaShare2: function(el){new YaShare2(el)},
        Winners: function(el){new Winners(el)},
        Help: function(el){new Help(el)}
    },
    run:function(wrapper, attr, data){
        var wrapper = wrapper || document,
            attr = attr || 'data-modules',
            elementAll = wrapper.querySelectorAll('['+ attr +']'),
            moduleAll = {}; /* ключи - названия модулей, значения - сами модули */

        //
        for(var i=0,j=elementAll.length; i<j; i++){
            var el = elementAll[i],
                nameAll = el.getAttribute(attr).split(' ');

            for(var m=0,n=nameAll.length; m<n; m++){
                var name = nameAll[m];

                if(!this.actions[name]){
                    try {console.error('модуль '+ name +' не найден')} catch(e){};
                    continue;
                }

                if(!moduleAll[name]) moduleAll[name] = [];
                moduleAll[name].push(this.actions[name](el, data));
            }
        }
        return moduleAll;
    },
    destroy:function(moduleAll){
        for(var name in moduleAll){
            var arr = moduleAll[name];
            for(var i=0,j=arr.length; i<j; i++){
                var module = arr[i];
                if(module && module.del) module.del();
            }
        }
    }
};

ready(function(){
    APP.modules.run();
});

//
svg(
	document,
	document.getElementsByTagName('use'),
	window.requestAnimationFrame || window.setTimeout,
	{},
	/Trident\/[567]\b/.test(navigator.userAgent) || /Edge\/12/.test(navigator.userAgent) || (navigator.userAgent.match(/AppleWebKit\/(\d+)/) || [])[1] < 538
);





